import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@components/icons/close/close';
import LogoIcon from '@components/icons/logo/logo';
import Link from 'next/link';
import StyledEducationTabletHeader from './educationTabletHeader.style';

function EducationTabletHeader({ uri }) {
  return (
    <StyledEducationTabletHeader>
      <div className="header__wrapper">
        <Link href={`${uri}`}>
          <CloseIcon />
        </Link>
        <div className="header__wrapper-logo">
          <LogoIcon />
        </div>
      </div>
    </StyledEducationTabletHeader>
  );
}

EducationTabletHeader.propTypes = {
  uri: PropTypes.string.isRequired
};

export default EducationTabletHeader;
